import React from 'react';

const ForgotSuccess = () => (
  <div>
    <div className="modal-header">
      <div className="zola-weddings-logo-black-100 center-block" />
      <h1 className="h1 text-center">Thanks!</h1>
      <div className="help-block text-center">
        We&#39;ve sent you a link to change your password.
        <br />
        If you are still unable to log in, please contact{' '}
        <a href="https://help.zola.com/hc" target="_blank" rel="noopener noreferrer">
          customer support
        </a>{' '}
        for assistance.
      </div>
    </div>
    <div className="modal-footer" />
  </div>
);

export default ForgotSuccess;



// WEBPACK FOOTER //
// ./src/components/ForgotSuccess.jsx